import { CoreIcon } from '../core-icon';
import bankMastercardSVG from '../../assets/logos/bank-mastercard.svg';
import type { IconProps } from '../core-icon';

export const BankMastercardIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankMastercardSVG} {...props} />;
};
